
import { UsersManagmentService } from './../../core-lib/services/users-managment/users-managment.service';
import { Component, inject, OnInit } from '@angular/core';
import { HotelService } from 'app/shared/hotel/hotel.service';
import { UtilService } from 'app/shared/util.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { HotelDto } from 'app/shared/model';

@Component({
    selector: 'mh-contact-executive',
    templateUrl: './contact-executive.component.html',
    standalone: false
})
export class ContactExecutiveComponent implements OnInit {
  // Propiedades del usuario
  userName: string = '';
  userPosition: string = '';
  userProfileImage: string | null = null;
  usersManagementService =  inject(UsersManagmentService);
  mobile: string;
  userEmail: any;
  calendar: any;
  hotelShow: any;
  hotelService = inject(HotelService);
  utilService = inject(UtilService);
  translate = inject(TranslateService);
  cs_executive: any;
  isLoading: boolean = true;
  currentUser;
  

  constructor() {}

  ngOnInit(): void {
    const currentCustomer = this.utilService.getCurrentCustomer();
    this.hotelService.getHotel(currentCustomer.id).subscribe((hotel: HotelDto) => {
      this.hotelShow = hotel;
      this.cs_executive = this.hotelShow.cs_executive;
      this.currentUser = this.utilService.getCurrentUser();

      this.getUserPersonalInformation();
    });
  }

  async getUserPersonalInformation(): Promise<void> {
    this.isLoading = true;
    try {
      const response = await this.usersManagementService.findUserById(this.cs_executive ?? environment.onGoingManagerId ).toPromise() as any;
      this.userProfileImage = response?.profile_photo;
      this.userName = response?.first_name + ' ' + response?.last_name;
      this.userPosition = response?.company_position;
      this.mobile = response?.mobile_number;
      this.userEmail = response?.email;
      this.calendar = response?.user_calendar?.calendar;
    } catch (error) {
      console.error('Error al obtener la información del usuario:', error);
    } finally {
      this.isLoading = false;
    }
  }

  onCallClick(): void {
    window.open(this.calendar, '_blank');
    this.utilService.ga('', ' click-call-executive');
  }

  onEmailClick(): void {
    const mailtoLink = `mailto:${this.userEmail}`;
    window.open(mailtoLink, '_blank');
    this.utilService.ga('', ' click-email-executive');
  }

  onWhatsAppClick(): void {
    const userName = this.currentUser.name + ' ' + this.currentUser.lastName;
    const customerName = this.hotelShow?.name || '';
    const message = this.translate.instant('support.menu-header.contact_executive.wsp_message', { userName, customerName });

    const messageEncoded = encodeURIComponent(message);
    const url = `https://wa.me/${this.mobile}?text=${messageEncoded}`;
    window.open(url, '_blank');
    this.utilService.ga('', ' click-whatsapp-executive');
  }
}
